import { jsx as _jsx } from "react/jsx-runtime";
import { automationsGridItems, TOP_VIDEO_PROPS } from "./automations-tab-consts.js";
import { withGenericConfig } from "/contexts/generic-config-context";
import LiveBoardTabComponent from "../live-board-tab-component";
const AutomationsTabContentComponent = (props)=>{
    const { translate, onCardClick } = props;
    return /*#__PURE__*/ _jsx("div", {
        className: "automations-tab-content",
        children: /*#__PURE__*/ _jsx(LiveBoardTabComponent, {
            description: translate("liveBoard.automationsTab.description"),
            gridItems: automationsGridItems,
            hideCardParagraph: true,
            onCardClick: onCardClick,
            topAssetProps: TOP_VIDEO_PROPS,
            hideVideoControls: true,
            onAssetClick: onCardClick
        })
    });
};
export default withGenericConfig(AutomationsTabContentComponent);
